import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-overlay-loader',
  templateUrl: 'overlay-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayLoaderComponent {
  @Input()
  public position: 'top'|'center' = 'center';

  public get spinnerClasses(): string[] {
    switch (this.position) {
    case 'top':
      return [
        'align-items-start',
        'pt-20',
      ];
    case 'center':
      return [
        'align-items-center'
      ];
    }
  }
}
